import { createTRPCClient, httpBatchLink, loggerLink } from '@trpc/client'
import SuperJSON from 'superjson'

import { env } from '@/env'
import { getBaseUrl } from '@/utils'

import { type AppRouter } from '../server/api/root'

export const vanillaApiClient = createTRPCClient<AppRouter>({
  links: [
    loggerLink({
      enabled: (op) =>
        env.NODE_ENV === 'development' ||
        (op.direction === 'down' && op.result instanceof Error),
    }),
    httpBatchLink({
      url: getBaseUrl() + '/api/trpc',
      transformer: SuperJSON,
    }),
  ],
})
